export default "__VITE_ASSET__CVve__7C__"